// ---- Theme ----
// Dark only. The light palette was removed with the toggle.
document.documentElement.setAttribute('data-theme', 'dark');

// ---- Mobile nav ----
document.addEventListener('click', (e) => {
  const open = e.target.closest('[data-nav-open]');
  const close = e.target.closest('[data-nav-close]');
  const nav = document.getElementById('nav');
  if (!nav) return;
  if (open) {
    nav.classList.add('open');
    nav.querySelector('a')?.focus();
  }
  if (close || (nav.classList.contains('open') && e.target.closest('#nav a'))) {
    nav.classList.remove('open');
  }
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') document.getElementById('nav')?.classList.remove('open');
});

// ---- Scroll reveal ----
const io = new IntersectionObserver(
  (entries) => {
    entries.forEach((en) => {
      if (en.isIntersecting) {
        en.target.classList.add('in');
        io.unobserve(en.target);
      }
    });
  },
  { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
);
document.querySelectorAll('.reveal').forEach((el, i) => {
  el.style.transitionDelay = `${Math.min(i % 4, 3) * 70}ms`;
  io.observe(el);
});

// ---- Toggle groups (chips, swatches, tabs) ----
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-group]');
  if (!btn) return;
  const group = btn.getAttribute('data-group');
  const attr = btn.hasAttribute('aria-selected') ? 'aria-selected' : 'aria-pressed';
  document
    .querySelectorAll(`[data-group="${group}"]`)
    .forEach((b) => b.setAttribute(attr, 'false'));
  btn.setAttribute(attr, 'true');

  // swatch label
  const out = document.querySelector(`[data-group-out="${group}"]`);
  if (out) out.textContent = btn.dataset.label || btn.textContent.trim();

  // collection filtering
  if (group === 'carry') {
    const val = btn.dataset.filter;
    document.querySelectorAll('[data-carry]').forEach((card) => {
      const show = val === 'all' || card.dataset.carry.split(' ').includes(val);
      card.hidden = !show;
    });
    const n = document.querySelectorAll('[data-carry]:not([hidden])').length;
    const cnt = document.querySelector('.filter-count');
    if (cnt) cnt.textContent = `${n} ${n === 1 ? 'model' : 'models'}`;
  }

  // kydex swatch filtering
  if (group === 'kydexfilter') {
    const val = btn.dataset.filter;
    document.querySelectorAll('[data-swatch]').forEach((card) => {
      card.hidden = !(val === 'all' || card.dataset.swatchGroup === val);
    });
    const n = document.querySelectorAll('[data-swatch]:not([hidden])').length;
    const cnt = document.querySelector('[data-swatch-count]');
    if (cnt) cnt.textContent = `${n} ${n === 1 ? 'color' : 'colors'}`;
    const empty = document.querySelector('[data-swatch-empty]');
    if (empty) empty.hidden = n !== 0;
  }

  // pdp tabs
  if (group === 'tab') {
    const panel = btn.dataset.panel;
    document.querySelectorAll('[data-tabpanel]').forEach((p) => {
      p.hidden = p.dataset.tabpanel !== panel;
    });
  }
});

// ---- PDP gallery ----
document.addEventListener('click', (e) => {
  const th = e.target.closest('.thumb');
  if (!th) return;
  document.querySelectorAll('.thumb').forEach((t) => t.setAttribute('aria-current', 'false'));
  th.setAttribute('aria-current', 'true');
  const main = document.getElementById('gallery-main-img');
  if (main) {
    main.src = th.querySelector('img').src;
    main.alt = th.querySelector('img').alt;
  }
});

// ---- Cart count refresh after add-to-cart (AJAX) ----
async function pchRefreshCart() {
  try {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const c = await r.json();
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = c.item_count;
      el.hidden = c.item_count === 0;
    });
  } catch (e) {}
}

document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[action$="/cart/add"]');
  if (!form || form.hasAttribute('data-no-ajax')) return;
  e.preventDefault();
  const btn = form.querySelector('[type="submit"]');
  const label = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
  const note = form.querySelector('[data-form-note]');
  if (note) { note.textContent = ''; note.classList.remove('is-error'); }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
    await pchRefreshCart();
    if (note) note.textContent = 'Added to cart.';
    document.querySelectorAll('[data-cart-flash]').forEach((el) => {
      el.hidden = false;
      clearTimeout(el._t);
      el._t = setTimeout(() => { el.hidden = true; }, 4000);
    });
  } catch (err) {
    if (note) { note.textContent = err.message; note.classList.add('is-error'); }
    else form.setAttribute('data-no-ajax', ''), form.submit();
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = label; }
  }
});

// ---- Cart line quantity ----
document.addEventListener('change', (e) => {
  const q = e.target.closest('[data-cart-qty]');
  if (!q) return;
  q.closest('form')?.requestSubmit();
});

// ---- Sticky header shadow ----
const pchHeader = document.querySelector('.site-header');
if (pchHeader) {
  const onScroll = () => pchHeader.classList.toggle('is-stuck', window.scrollY > 8);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

// ---- Variant picker ----
document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
  const form = picker.closest('form');
  const json = picker.querySelector('[data-variant-json]');
  if (!form || !json) return;
  let variants = [];
  try { variants = JSON.parse(json.textContent); } catch (e) { return; }
  const hidden = form.querySelector('[data-variant-id]');
  const submit = form.querySelector('[type="submit"]');

  const update = () => {
    const chosen = [];
    picker.querySelectorAll('input[type="radio"]:checked').forEach((r) => {
      chosen[Number(r.dataset.optIndex)] = r.value;
      const label = r.closest('[data-opt-chip]');
      picker
        .querySelectorAll(`input[name="${r.name}"]`)
        .forEach((s) => s.closest('[data-opt-chip]').setAttribute('aria-pressed', 'false'));
      if (label) label.setAttribute('aria-pressed', 'true');
      const out = picker.querySelector(`[data-group-out="opt-${Number(r.dataset.optIndex) + 1}"]`);
      if (out) out.textContent = r.value;
    });
    const match = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
    if (hidden) hidden.value = match ? match.id : '';
    if (submit) {
      submit.disabled = !match || !match.available;
      if (!match) submit.textContent = 'Unavailable';
      else if (!match.available) submit.textContent = 'Sold out';
      else submit.textContent = submit.dataset.addLabel || submit.textContent;
    }
    const priceEl = document.querySelector('.pdp-price .price__amount');
    if (priceEl && match) {
      priceEl.textContent = (match.price / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      });
    }
  };

  if (submit) submit.dataset.addLabel = submit.textContent.trim();
  picker.addEventListener('change', update);
  update();
});

// ---- Kydex swatch lightbox ----
(function () {
  const lb = document.querySelector('[data-swatch-lightbox]');
  if (!lb) return;
  const img = lb.querySelector('[data-swatch-lb-img]');
  const nameEl = lb.querySelector('[data-swatch-lb-name]');
  const noteEl = lb.querySelector('[data-swatch-lb-note]');
  let lastFocus = null;

  function open(btn) {
    const src = btn.dataset.src;
    if (src) {
      img.src = src;
      img.alt = btn.dataset.name || '';
      img.hidden = false;
    } else {
      img.hidden = true;
    }
    nameEl.textContent = btn.dataset.name || '';
    noteEl.textContent = btn.dataset.note || '';
    lastFocus = btn;
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
    const closeBtn = lb.querySelector('.swatch-lightbox__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    lb.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-swatch-zoom]');
    if (btn) {
      open(btn);
      return;
    }
    if (e.target.closest('[data-swatch-close]')) close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !lb.hidden) close();
  });
})();
